import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { PaymentDetailsCss as useStyles } from './PaymentDetailsSideBarCss';
import RightSideBar from '../../RightSideBar/RightSideBar';
import * as logger from '../../../../logger';
import {
    CardContent,
    CardHeader,
    Card,
    Grid,
    ListItem,
    List,
    Drawer,
    Button,
    Dialog,
    DialogContent,
    DialogActions
} from '@material-ui/core';
import { SideBarDialogContent, SideBarDialogTitle, SideBarDialogActions } from '../../Dialog/Dialog';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { PendingIcon } from '../../../../components/icons';
import { deleteSingleDriverTransaction, fetchSingleDriverTransaction, driverAdditionType, driverDeductionType, fetchDriverOnlineTransaction } from '../../../../store/actions/vehicleActionCreator';
import { updateChatView } from "../../../../store/actions/userActionCreators";
import { numberFormat, getMilliDatePickerDateInStringDDMMMYYYY } from '../../../../utils/utils';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import DriverGaveAndGot from '../DriverGaveAndGot';


const PaymentDetailsSideBar = ({ user, vehicle, rightSideBarOpen, onClose, onDelete, selectedRow, dispatchChatView, dispatchFetchSingleDriverTransaction, dispatchDeleteSingleTransaction, dispatchFetchSingleDriverOnlineTransaction }) => {

    const [dialogOpen, setDialogOpen] = useState(rightSideBarOpen);
    const [singleTransactInfo, setSingleTransactInfo] = useState({});
    const [driverGaveGotDialog, setDriverGaveGotDialog] = useState(false);
    const [type, setType] = useState("");
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [recall, setRecall] = useState(false);

    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let driverIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

    const classes = useStyles();

    useEffect(() => {

        dispatchChatView(false);

        if (selectedRow && selectedRow.is_broker_enabled) {

            dispatchFetchSingleDriverOnlineTransaction(selectedRow.id,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Payment Details Side Bar Dweb", 'SuccessFull, Single Driver Online transaction');
                    }
                },
                () => {
                    logger.log("Payment Details Side Bar Dweb", 'Failed, Single Driver Online transaction');
                }
            )

        } else {
            dispatchFetchSingleDriverTransaction(selectedRow.id,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Payment Details Side Bar Dweb", 'SuccessFull, Single Driver transaction');
                    }
                },
                () => {
                    logger.log("Payment Details Side Bar Dweb", 'Failed, Single Driver transaction');
                }
            )
        }

    }, [rightSideBarOpen, recall]);

    useEffect(() => {

        if (selectedRow && selectedRow.is_broker_enabled) {
            if (vehicle && vehicle.singleDriverTransactionOnline) {
                setSingleTransactInfo(vehicle.singleDriverTransactionOnline);
            }
        } else {
            if (vehicle && vehicle.singleDriverTransaction) {
                setSingleTransactInfo(vehicle.singleDriverTransaction);
            }
        }
    }, [vehicle.singleDriverTransaction, vehicle.singleDriverTransactionOnline]);

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        dispatchChatView(true);
    }

    const handleEditTransact = () => {

        const amount = selectedRow && selectedRow.amount ? selectedRow.amount : 0
        if(selectedRow && selectedRow.id){
            dispatchFetchSingleDriverTransaction(selectedRow.id,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Payments Details Side Bar Dweb", 'SuccessFull, Single transaction ');
                        if (amount < 0) {
                            setType("driverGave");
    
                            // dispatchGetDriverDeductionTypes(
                            //     () => {
                            //     },
                            //     () => {
                            //     }
                            // );
                        } else {
                            setType("driverGot");
    
                            // dispatchGetDriverAdditionTypes(
                            //     () => {
                            //     },
                            //     () => {
                            //     }
                            // );
                        }
                        setDriverGaveGotDialog(true);
                    }
                },
                () => {
                    logger.log("Payments Details Side Bar Dweb", 'Failed, Single transaction ');
                }
            );
        }
    }

    const handleDeleteTransact = () => {
        setDeleteDialog(true);
    }

    const handleBalanceClose = () => {
        setDriverGaveGotDialog(false);
    }

    const handleDeleteDialogClose = () => {
        setDeleteDialog(false);
    }

    const onDeleteTransaction = () => {
        dispatchDeleteSingleTransaction(selectedRow.id,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single driver Component Dweb", "Delete transaction successfull");
                    setDeleteDialog(false);
                    onDelete();
                }
            },
            () => {
                logger.log("Single driver Component Dweb", "Delete transaction failed");
            }
        );
    }

    const handleConfirm = () => {
        setDriverGaveGotDialog(false);
        setRecall(!recall);
    }

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={dialogOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >

                <SideBarDialogTitle id={"right-sidebar-for-payment-details"} siderBarType={'truckBook'} onClose={handleClose} className={classes.dialogTitleV1}>
                    <div className={classes.divTitleContainer}>
                        <div className={classes.divTitle}>
                            Transaction Details
                        </div>
                        {selectedRow && !selectedRow.is_broker_enabled &&
                            <div className={classes.divAlign}>
                                <div className={classes.mrV1}>
                                    <IconButton className={classes.editButton} onClick={() => handleEditTransact()}>
                                        <EditIcon className={classes.editIcon} />
                                    </IconButton>
                                </div>
                                <div>
                                    <IconButton className={classes.deleteButton} onClick={() => handleDeleteTransact()}>
                                        <DeleteIcon className={classes.deleteIcon} />
                                    </IconButton>
                                </div>
                            </div>
                        }
                    </div>
                </SideBarDialogTitle>
                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >

                    <Card className={classes.cardV1}>
                        {selectedRow && selectedRow.is_broker_enabled &&
                            <CardHeader
                                avatar={
                                    <div className={classes.avatar}>
                                        {singleTransactInfo && singleTransactInfo.paymentStatus && (singleTransactInfo.paymentStatus).toLowerCase() == "success" &&
                                            <CheckCircleIcon className={classes.doneIcon} />
                                        }
                                        {singleTransactInfo && singleTransactInfo.paymentStatus && (singleTransactInfo.paymentStatus).toLowerCase() == "pending" &&
                                            <PendingIcon className={classes.pendingIcon} />
                                        }
                                    </div>
                                }
                                title={<div className={classes.divPayment}>
                                    {singleTransactInfo && singleTransactInfo.paymentStatus && (singleTransactInfo.paymentStatus).toLowerCase() == "success" &&
                                        <>
                                            Payment Successful
                                        </>
                                    }
                                    {singleTransactInfo && singleTransactInfo.paymentStatus && (singleTransactInfo.paymentStatus).toLowerCase() == "pending" &&
                                        <>
                                            Payment Pending
                                        </>
                                    }
                                </div>}
                                className={singleTransactInfo && singleTransactInfo.paymentStatus ? (singleTransactInfo.paymentStatus).toLowerCase() == "success" ? classes.cardHeader : (singleTransactInfo.paymentStatus).toLowerCase() == "pending" ? classes.cardHeaderPending : "" : ""}
                            // classes.cardHeaderPending
                            />
                        }
                        <CardContent className={classes.cardContent} >

                            {/* ********************************* 1st Row ************************************ */}
                            <Grid container justify="space-between" wrap="nowrap">
                                <Grid item>
                                    <div className={classes.titleV1}>Payment Date</div>
                                    {selectedRow && selectedRow.is_broker_enabled &&
                                        <div className={classes.textV1}>{singleTransactInfo && singleTransactInfo.date ? getMilliDatePickerDateInStringDDMMMYYYY(singleTransactInfo.date) : "--"}</div>
                                    }
                                    {selectedRow && !selectedRow.is_broker_enabled &&
                                        <div className={classes.textV1}>{singleTransactInfo && singleTransactInfo.transactionDate ? getMilliDatePickerDateInStringDDMMMYYYY(singleTransactInfo.transactionDate) : "--"}</div>
                                    }
                                </Grid>
                                <Grid item>
                                    <div className={classes.titleV2}>Payment Amount</div>
                                    <div className={classes.textV3}>{numberFormat(singleTransactInfo && singleTransactInfo.amount ? singleTransactInfo.amount : 0)}</div>
                                </Grid>
                            </Grid>

                            {/* ***************************************** 2nd Row ********************************** */}
                            {selectedRow && selectedRow.is_broker_enabled &&
                                <Grid container justify="space-between" className={classes.mtV1} wrap="nowrap">
                                    <Grid item>
                                        <div className={classes.titleV1}>Bank</div>
                                        <div className={classes.textV1}>{singleTransactInfo && singleTransactInfo.bankName ? singleTransactInfo.bankName : "--"}</div>
                                    </Grid>
                                    <Grid item>
                                        <div className={classes.titleV2}>Transcation ID</div>
                                        <div className={classes.textV2}>{singleTransactInfo && singleTransactInfo.paymentRefId ? singleTransactInfo.paymentRefId : "--"}</div>
                                    </Grid>
                                </Grid>
                            }

                            {/* *************************************** 3rd Row *********************************** */}
                            {selectedRow && selectedRow.is_broker_enabled &&
                                <Grid container justify="space-between" className={classes.mtV1} wrap="nowrap">
                                    <Grid item>
                                        <div className={classes.titleV1}>Account</div>
                                        <div className={classes.textV1}>{singleTransactInfo && singleTransactInfo.accNumber ? singleTransactInfo.accNumber : "--"}</div>
                                    </Grid>
                                </Grid>
                            }

                            {/* ***************************************** 4th Row. ***************************************** */}
                            <Grid container justify="space-between" className={classes.mtV1} wrap="nowrap">
                                <Grid item>
                                    <div className={classes.titleV1}>Reason for Sending Money</div>
                                    {selectedRow && selectedRow.is_broker_enabled &&
                                        <div className={classes.textV4}>{singleTransactInfo && singleTransactInfo.description ? singleTransactInfo.description : "--"}</div>
                                    }
                                    {selectedRow && !selectedRow.is_broker_enabled &&
                                        <div className={classes.textV4}>{singleTransactInfo && singleTransactInfo.displayName ? singleTransactInfo.displayName : "--"}</div>
                                    }
                                </Grid>
                            </Grid>

                            {selectedRow && !selectedRow.is_broker_enabled &&
                                <Grid container justify="space-between" className={classes.mtV1} wrap="nowrap">
                                    <Grid item>
                                        <div className={classes.titleV1}>Notes</div>
                                        <div className={classes.textV4}>{singleTransactInfo && singleTransactInfo.description ? singleTransactInfo.description : "--"}</div>
                                    </Grid>
                                </Grid>
                            }

                        </CardContent>
                    </Card>

                </SideBarDialogContent>
                <SideBarDialogActions className={classes.sideBarActions} >
                    <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
                        Close
                    </Button>
                </SideBarDialogActions>

            </Drawer>

            {/* **************************************** Transaction Delete Dialog. **************************************** */}
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={deleteDialog} onClose={handleDeleteDialogClose}
            >
                <DialogContent>
                    <div className={classes.divV25}> Delete Transaction</div>
                    <div className={classes.mtV5}>Are you sure you want to delete</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteDialogClose}>
                        <span className={classes.cancelV1}>
                            CANCEL
                        </span>
                    </Button>
                    <Button onClick={onDeleteTransaction}>
                        <span className={classes.deleteV1}>
                            DELETE
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>

            {driverGaveGotDialog && <DriverGaveAndGot balanceType={type} onClose={handleBalanceClose} onOpen={driverGaveGotDialog} driverId={driverIdValue ? driverIdValue : ""} onEdit={true} onConfirm={handleConfirm} />}

        </>
    )
}

export const mapStateToProps = (state) => (state);
export const mapDispatchToProps = (dispatch) => ({

    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchFetchSingleDriverTransaction: (id, onSuccess, onFailure) => {
        dispatch(fetchSingleDriverTransaction(id, onSuccess, onFailure))
    },
    dispatchDeleteSingleTransaction: (id, onSuccess, onFailure) => {
        dispatch(deleteSingleDriverTransaction(id, onSuccess, onFailure))
    },
    dispatchFetchSingleDriverOnlineTransaction: (id, onSuccess, onFailure) => {
        dispatch(fetchDriverOnlineTransaction(id, onSuccess, onFailure))
    }

});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDetailsSideBar);